import moment from 'moment';

const THOUSAND = 1000;
const MILLION  = 1000000;
const BILLION  = 1000000000;

// HELPER FUNCTIONS
const truncateMiddle = ({ text = '', charsbefore }) => {
  if (text.length < charsbefore)
    return text;

  const division = charsbefore / 2;

  const before = text.substring(0, division);

  const after = text.substring(text.length - division, text.length);

  return `${before}...${after}`;
};

const truncateEnd = ({ text = '', charsbefore }) => {
  const before = text.substring(0, charsbefore);

  return `${before}...`;
};

const isUnit = (unit, number) => {
  let remainder = 0;
  switch (unit) {
    case 'thousandth':
      remainder = number / THOUSAND;
      break;
    case 'millionth':
      remainder = number / MILLION;
      break;
    case 'billionth':
      remainder = number / BILLION;
      break;
  }

  return remainder > 0 && remainder < THOUSAND;
};

const hasDecimal = (number) => {
  if (isNaN(number)) return false;
  return parseFloat(number.toFixed(0)) !== parseFloat(number.toFixed(1));
};


// MAIN FUNCTIONS
const numberFormatter = (number) => {
  if (isNaN(number)) return 0;

  let _number = number;

  if (isUnit('thousandth', number)) {
    _number = _number / THOUSAND;
    const formattedNumber = hasDecimal(_number) ? `${_number.toFixed(1)}k` : `${_number.toFixed(0)}k`;
    return formattedNumber;
  }

  if (isUnit('millionth', number)) {
    _number = _number / MILLION;
    const formattedNumber = hasDecimal(_number) ? `${_number.toFixed(1)}m` : `${_number.toFixed(0)}m`;
    return formattedNumber;
  }

  return _number;
};

const memorySizeFormatter = (number, decimal = 2) => {
  if (isNaN(number) || !number) return '-';

  let _number = number;

  if (isUnit('thousandth', number)) {
    _number = _number / THOUSAND;
    return `${_number.toFixed(decimal)} KB`;
  }

  if (isUnit('millionth', number)) {
    _number = _number / MILLION;
    return `${_number.toFixed(decimal)} MB`;
  }

  if (isUnit('billionth', number)) {
    _number = _number / BILLION;
    return `${_number.toFixed(decimal)} GB`;
  }

  return `${_number} Bytes`
};

const formatDate = (date) => {
  return moment(date).format('dddd, MMM DD YYYY [at] hh:mm a');
}

const formatDateFromNow = (date) => {
  return moment(date).fromNow();
}

const truncateText = (text, options = {}) => {
  const { position = 'middle', charsbefore = 25 } = options;

  switch (position) {
    case 'middle':
      return truncateMiddle({text, charsbefore});
      break;
    case 'end':
      return truncateEnd({text, charsbefore});
  }
};

export default {
  formatDate,
  formatDateFromNow,
  numberFormatter,
  memorySizeFormatter,
  truncateText,
}